<template>
    <div class="page-content">
        <!-- header -->
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
            <div class="mb-2">
                <div class="my-2">
                    <h3 class="mb-2 mb-md-0"> Behavioural Report Recommendation</h3>
                </div>
            </div>
            <div class="d-flex gap-2">
                <div class="top_heading_CreatePartner_btn position-relative z-index-999 me-2" id="tour-search-web-icon"
                    :class="this.componentTour == true ? 'disable-tour-selection' : ''">
                    <div class="Group_top_three_dot">
                        <div class="Searching_input-box" style="cursor: pointer;">
                            <input type="text" v-model="Search" @keydown.enter="filteredList()"
                                placeholder="Search..." />
                            <span class="icon Group_top_three_dot_dropdown" @click="opensearch">
                                <img src="../../../public/dashboard-assets/images/M2/Icon-Set.png" alt=""
                                    class="Searching_search_icon" />
                            </span>
                            <img src="../../../public/dashboard-assets/images/M2/Close_icon.png" alt=""
                                class="close-icon" @click="closesearch" />
                        </div>
                    </div>
                </div>
                <div class="d-flex">
                    <button type="button" class="float-end modail_submit_button  bulkButton mx-2"
                        style="cursor: pointer;">
                        <input id="fileInput" type="file" class="file-upload-input" style="cursor: pointer;"
                            v-on:click="$event.target.value = ''" v-on:change="handleFileUpload($event)"
                            accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                        <i class=" fa-solid fa-upload pe-2" style="cursor: pointer;"></i>Upload Template
                        Sheet</button>

                    <!-- <div class="col-12 col-sm-12 col-md-3 col-lg-4"> -->
                    <button type="button" class=" float-end modail_submit_button  bulkButton mx-2"
                        @click="DownloadUploadSheet()">
                        <i class="fa-solid fa-download pe-1" style="color: #7b68ee;"></i>
                        Download Template Sheet
                    </button>
                    <!-- </div> -->
                </div>
            </div>
        </div>

        <div>
            <div class="card p-4" style="z-index: 0;" v-if="this.BehavioralReportRecommendationList.length>0">
                <div class="table-responsive" style="width: 100%;">
                    <table class="table styled-table ">
                        <thead>
                            <tr>
                                <th> Id </th>
                                <!-- <th> Type </th> -->
                                <th> DisplayType </th>
                                <th>
                                    <div class="filter-container ">
                                        <button v-if="this.activeFilter == true && !(/^\d+$/.test(this.Search))"
                                            ref="filterButton" @click.stop="toggleFilterDropdown"
                                            class="btn p-0 Group_top_three_dot_dropdown">
                                            <i v-if="this.selectedFilters.length === 0" class="bi bi-funnel"></i>
                                            <i v-else class="bi bi-funnel-fill"></i>
                                        </button>
                                        PsySecId
                                    </div>
                                </th>
                                <th>
                                    <div class="filter-container m-0">
                                        <button v-if="this.activeFilter == true && /^\d+$/.test(this.Search)"
                                            ref="filterButton" @click.stop="toggleFilterDropdown"
                                            class="btn p-0 Group_top_three_dot_dropdown">
                                            <i v-if="this.selectedFilters.length === 0" class="bi bi-funnel"></i>
                                            <i v-else class="bi bi-funnel-fill"></i>
                                        </button>
                                        CompetencyId
                                    </div>
                                </th>
                                <th>Competency<br>Name</th>
                                <th>Sequence</th>
                                <th> TextType </th>
                                <th> DependentText </th>
                                <th> Content </th>
                                <th> Edit </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in BehavioralReportRecommendationList" :key="index"
                                style="width: max-content;">

                                <template v-if="editIndex == index">
                                    <td>{{ item.id }}</td>
                                    <!-- <td>{{ item.type }}</td> -->
                                    <!-- <td style=" max-width: 300px; word-wrap: break-word; white-space: normal;">{{ item.displayType }}</td> -->
                                    <td>
                                        <label class="input-hero me-2">
                                            <select class="input_area select_ca p-1" type="text"
                                                v-model="this.editedInstance.displayType">
                                                <option>
                                                    About Behavioural <br> Interview Questions
                                                </option>
                                                <option>
                                                    About Managerial Counsel
                                                </option>
                                                <option>
                                                    Basic Guidelines
                                                </option>
                                                <option>
                                                    Managerial Recommendation
                                                </option>
                                                <option>
                                                    Questions
                                                </option>
                                                <option>
                                                    Suggested Script
                                                </option>
                                            </select>
                                        </label>
                                    </td>
                                    <!-- <td>{{ item.psySecId }}</td> -->
                                    <td><input v-model="this.editedInstance.psySecId" type="Number"
                                            class="form-control"></td>
                                    <!-- <td>{{ item.competencyId }}</td> -->
                                    <td><input v-model="this.editedInstance.competencyId" type="Number"
                                            class="form-control"></td>
                                    <td style=" max-width: 300px; word-wrap: break-word; white-space: normal;">{{
                                        item.competencyName }}</td>
                                    <td><input v-model="this.editedInstance.sequence" type="Number"
                                            class="form-control"></td>
                                    <td style="width: 10%;">

                                        <label class="input-hero me-2">
                                            <select class="input_area select_ca p-1" type="text"
                                                style="width: max-content;" v-model="this.editedInstance.textType">
                                                <option>
                                                    Html
                                                </option>
                                                <option>
                                                    N-Indicator
                                                </option>
                                                <option>
                                                    Paragraph
                                                </option>
                                                <option>
                                                    P-Indicator
                                                </option>
                                                <option>
                                                    Pointer
                                                </option>

                                            </select>
                                        </label>
                                    </td>
                                    <td><input v-model="this.editedInstance.dependentText" type="Number"
                                            class="form-control"></td>

                                    <td><textarea style="width: 100%;" rows="6" class="form-control"
                                            v-model="this.editedInstance.content"></textarea>
                                    </td>

                                    <td>
                                        <div class="d-block m-3">
                                            <div class="my-2">
                                                <button type="button" class="btn btn-primary"
                                                    style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"
                                                    @click="updateRecord(index)">
                                                    <i class="fa-regular fa-circle-check fa-lg"></i>
                                                </button>
                                            </div>
                                            <div >
                                                <button type="button" class="btn btn-primary"
                                                    style="background-color: #F1F0FF; margin-left: 5%; color:#7b68ee; font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"
                                                    @click="Reset(index)">
                                                    <i class="bi bi-x-circle"></i>
                                                </button>
                                            </div>

                                        </div>

                                        <!-- </td>

                                    <td> -->
                                    </td>


                                </template>

                                <template v-else>
                                    <td>{{ item.id }}</td>
                                    <!-- <td>{{ item.type }}</td> -->
                                    <td style=" max-width: 300px; word-wrap: break-word; white-space: normal;">{{
                                        item.displayType }}</td>
                                    <td>{{ item.psySecId }}</td>
                                    <td>{{ item.competencyId }}</td>
                                    <TD style=" max-width: min-content; word-wrap: break-word; white-space: normal;">{{
                                        item.competencyName }}</TD>
                                    <td>{{ item.sequence }}</td>
                                    <td>{{ item.textType }}</td>
                                    <td>{{ item.dependentText }}</td>
                                    <td v-if="item.textType=='Html'" class="truncate-cell">
                                        <!-- <div style=" max-height: 200px;overflow-y: auto;">{{ item.content }}</div></td>style=" max-width: 300px; word-wrap: break-word; white-space: normal;" -->
                                        {{ item.content }}
                                    </td>
                                    <td v-else style=" max-width: 600px; word-wrap: break-word; white-space: normal;">
                                        <div style=" max-height: 200px;overflow-y: auto;">{{ item.content }}</div>
                                    </td>
                                    <!-- {{ item.content }} </td> -->
                                    <td>
                                        <button type="button" class="btn btn-primary"
                                            style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"
                                            @click="editItem(index)">
                                            <i class="fa-regular fa-pen-to-square fa-lg"></i>
                                        </button>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>



            </div>
            <div class="text-center" v-else>
                <img src="../../../public/dashboard-assets/images/M2/empty_record.png" style="width: 20%"
                    class="my-5" />
                <h3 class="ms-5 mt-2">No Details Found</h3>
            </div>



            <div class="p-3" v-if="this.BehavioralReportRecommendationList.length>0">
                <div :class="{ disabled: paginationIsDisabled, enabled: !paginationIsDisabled }"
                    :style="{ pointerEvents: paginationIsDisabled ? 'none' : 'auto' }">
                    <paginate v-model="currentPage" :page-count="Page_count" :margin-pages="1" :page-range="1"
                        :click-handler="clickCallback" :prev-text="'< Prev'" :next-text="'Next >'"
                        :container-class="'pagination'" :page-class="'page-item'">
                    </paginate>
                </div>
            </div>

        </div>
        <div ref="filterDropdown" style="display: none;">
            <div class="tippy-filter-content">
                <div class="filter-options">
                    <div class="search-bar p-1">
                        <form class="search-form">
                            <input type="text" v-model="searchfilter" @keyup="Filterresult" placeholder="Search"
                                class="form-control bg-white" /><button class="btn">
                                <i class="fas fa-search"></i>
                            </button>
                        </form>
                    </div>
                    <div v-for="option in filterList" :key="option" class="filter-option p-1">
                        <label>
                            <input type="checkbox" :checked="isSelected(option)" @change="toggleOption(option)" />
                            {{ option }}
                        </label>
                    </div>
                </div>
                <div class="filter-actions">
                    <button @click="applyFilter" class="btn btn-primary m-2">Apply</button>
                    <button @click="selectAllFilter" class="btn btn-primary m-2">Select All</button>
                    <button @click="clearFilter" class="btn btn-primary m-2">Clear</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Paginate from "vuejs-paginate-next";
import readXlsxFile from 'read-excel-file';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { validateSuperAdminUser } from '../../platformFeatures/featureUtils'
export default {
    name: "BehavioralReportRecommendation",
    components: {
        paginate: Paginate,
    },
    data() {
        return {
            BehavioralReportRecommendationList: [],
            PostRequestModel: null,

            currentPage: 1,
            Page_count: 1,
            offSet: 1,
            limit: 10,
            Search: '',

            downloadUrl: '',
            isDisabled: false,
            paginationIsDisabled: false,

            schema: {
                Id: 'number',
                Type: 'number',
                DisplayType: 'string',
                PsySecId: 'number',
                TestId: 'number',
                CompetencyId: 'number',
                Sequence: 'number',
                TextType: 'string',
                DependentText: 'number',
                Content: 'string'
            },
            validationErrors: [],
            competencyIdList: [],
            BehavioralReportRecommendationFilterList: [],
            filterList: [],
            searchfilter: '',
            tippyInstance: null,
            isFilterOpen: false,
            selectedFilters: [],
            activeFilter : false,
            editedInstance : null,
            editIndex: null,
            psySecIdList: [],
        }
    },
    created() {
        validateSuperAdminUser();
    },
    computed:{
        filteredData() {
            // If no filters are applied, return all data
            if (this.selectedFilters.length === 0) {
                return this.BehavioralReportRecommendationFilterList;
            }
            else if(/^\d+$/.test(this.Search)){
                return this.BehavioralReportRecommendationFilterList.filter(row => {
                    return this.selectedFilters.includes(row.competencyId); 
            });
            } 
            else{
                return this.BehavioralReportRecommendationFilterList.filter(row => {
                    return this.selectedFilters.includes(row.psySecId); 
            });
            }     
        }
    },
    methods: {
        ...mapActions([
            "GetBehaviouralReportRecommendation",
            "PostBehaviouralReportRecommendation",
            "ShowWarningMessage",
            "UpdateBehaviouralReportRecommendation"]),

        async getBehaviouralReportRecommendation(pageNum) {
            var response = await this.GetBehaviouralReportRecommendation({
                Limit: this.limit,
                OffSet: this.offSet,
                //Search : "",
            });

            if (response.status) {
                this.BehavioralReportRecommendationList = response.object.data.behaviouralReportRecommendation;
                //console.log(Math.ceil(response.object.data.filterCount / this.limit));
                //console.log(this.BehavioralReportRecommendationList);
            }
            this.Page_count = response
                ? Math.ceil(response.object.data.totalCount / this.limit)
                : 0;
            this.currentPage = pageNum ? pageNum : 1;
        },
        async clickCallback(pageNum) {
            this.offSet = (pageNum - 1) * this.limit + 1;
            if (this.Search.length > 0) {
                await this.filteredList(pageNum);
            }
            else {
                await this.getBehaviouralReportRecommendation(pageNum);
            }

        },
        async handleFileUpload(event) {
            if (event) {
                if (event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    this.ShowWarningMessage("Please select valid file format");
                    // console.log("Please select valid file format");
                    return;
                }
                var result = {};
                const file = event.target.files[0];
                const rows = await readXlsxFile(file, { sheet: "BehaviouralReportRecommendation" });
                const [header, ...dataRows] = rows;

                const jsonData = dataRows.map((row, rowIndex) => {
                    return header.reduce((obj, key, index) => {

                        const expectedType = this.schema[key];
                        //console.log(expectedType);
                        const Value = row[index];
                        if (key == "TextType") {
                            // console.log("shraddhapatel",Value,Value == "Pointer");
                            if (!(Value == "Html" || Value == "N-Indicator" || Value == "P-Indicator" || Value == "Paragraph" || Value == "Pointer")) {
                                this.validationErrors.push(`"Invalid entry in textType"`);
                            }
                        }

                        obj[key] = this.validateCellValue(Value, expectedType, key, rowIndex, this.validationErrors);
                        return obj
                    }, {})
                })
                result = jsonData;
                this.PostRequestModel = result
                // console.log("srult", result);
                // console.log("srult", this.validationErrors);
                if (this.validationErrors.length > 0) {
                    this.ShowWarningMessage(this.validationErrors.toString());
                }
                else {
                    await this.postBehaviouralReportRecommendation(this.PostRequestModel);
                }
            }

        },
        validateCellValue(value, expectedType, key,rowIndex, errors) {

            if (value === '' || value === undefined || value === null) {
                return null
            }
            //console.log(errors);
            const actualType = typeof value;
            //console.log(actualType);
            if (expectedType == 'number') {
                if (isNaN(Number(value))) {
                    // console.log("shraddha");
                    errors.push(`"${key}" should be a number."`);
                    return null
                }
                return Number(value)
            }

            if (expectedType === 'string') {
                if (actualType !== 'string') {
                    errors.push(`"${key}" should be a string."`)
                    return null
                }
                return value
            }

            if (expectedType === 'boolean') {
                if (value != 0 && value != 1) {
                    errors.push(`"${key}" should be a boolean."`)
                    return null
                }
                return value
            }
            return value
        },
        opensearch() {
            document.querySelector(".Searching_input-box").classList.add("open");
        },
        async closesearch() {
            document.querySelector(".Searching_input-box").classList.remove("open");
            this.Search = "";
            this.isDisabled = false;
            this.paginationIsDisabled = false;
            await this.filteredList();
        },
        async postCompetencyManagementMaster(data) {
            await this.PostCompetencyManagementMaster(data);
        },
        DownloadUploadSheet() {
            this.downloadUrl = 'https://testdelivery-mumbai.s3.ap-south-1.amazonaws.com/BulkUploadTemplate/Competency/BehaviouralReportRecommendation_Upload_Sheet.xlsx';
            window.open(this.downloadUrl);
        },
        async postBehaviouralReportRecommendation(data) {
            await this.PostBehaviouralReportRecommendation(data);
        },
        async filteredList(pageNum){
            var list;
            this.Search = this.Search.trim();
            this.offSet=0;
            this.limit=10;
            //console.log(this.Search);
            if (this.Search.toString().length === 0) {
                this.activeFilter = false;
            }
            else {
                this.activeFilter = true;
            }
            list = await this.GetBehaviouralReportRecommendation({
                OffSet: this.offSet,
                Limit: this.limit,
                searchString: encodeURIComponent(this.Search),
            });
            this.Page_count = list
                    ? Math.ceil(list.object.data.filterCount / this.limit)
                    : 0;
            this.currentPage = pageNum ? pageNum : 1;
            this.BehavioralReportRecommendationList = list.object.data.behaviouralReportRecommendation;
            
            if (/^\d+$/.test(this.Search)) {
                // console.log("shr");
                let all = await this.GetBehaviouralReportRecommendation({
                    OffSet: this.offSet,
                    Limit: 300,
                    searchString: encodeURIComponent(this.Search),
                });
                this.BehavioralReportRecommendationFilterList = all.object.data.behaviouralReportRecommendation;
                const ids = this.BehavioralReportRecommendationFilterList.map((p) => p.competencyId);
                this.competencyIdList = [...new Set(ids)];
                //console.log(this.competencyIdList);
                this.filterList = this.competencyIdList;
            }else{
                let all = await this.GetBehaviouralReportRecommendation({
                    OffSet: this.offSet,
                    Limit: 150,
                    searchString: encodeURIComponent(this.Search),
                });
                this.BehavioralReportRecommendationFilterList = all.object.data.behaviouralReportRecommendation;
                const ids = this.BehavioralReportRecommendationFilterList.map((p) => p.psySecId);
                this.psySecIdList = [...new Set(ids)];
                this.filterList = this.psySecIdList;
            }
            
            this.$nextTick(() => {
                this.initTippy();
            });
            //console.log(this.activeFilter);

        },
        // openFileInput() {
        //     this.$refs.fileInput.click();
        // },
        toggleFilterDropdown() {
            this.isFilterOpen = !this.isFilterOpen;

            if (this.isFilterOpen) {
                this.tippyInstance.show();
            } else {
                this.tippyInstance.hide();
            }

        },
        isSelected(option) {
            return this.selectedFilters.includes(option);
        },

        toggleOption(option) {
            const index = this.selectedFilters.indexOf(option);
            if (index === -1) {
                this.selectedFilters.push(option);
            } else {
                this.selectedFilters.splice(index, 1);
            }
        },
        applyFilter() {
            this.isFilterOpen = false;
            this.paginationIsDisabled = true;
            this.BehavioralReportRecommendationList = this.filteredData;
            this.tippyInstance.hide();
        },
        selectAllFilter(){
            this.filterList.forEach(element => {
                this.selectedFilters.push(element);
            });
        },
        clearFilter() {
            this.selectedFilters = [];
            this.isFilterOpen = false;
        },
        closeDropdown(event) {
            if (!event.target.closest('.filter-container') && this.isFilterOpen) {
                this.isFilterOpen = false;
            }
        },
        initTippy() {
            if (!this.$refs.filterButton || !this.$refs.filterDropdown) {
                //console.error('Filter refs not found');
                return;
            }
            this.tippyInstance = tippy(this.$refs.filterButton, {
                content: this.$refs.filterDropdown,
                theme: 'light',
                interactive: true,
                trigger: 'manual',
                placement: 'bottom',
                arrow: true,
                appendTo: document.body,
                maxWidth: 'none',
                onShow: () => {
                    // Ensure the content is visible when the tippy is shown
                    this.$refs.filterDropdown.style.display = 'block';
                },

            });
        },
        Filterresult() {
            //var temp = this.competencyRecommendationIdList
            if(this.activeFilter == true){
                this.filterList = this.competencyIdList.filter((element) =>
                element.toString()
                    .includes(this.searchfilter.toString())
            );
            }
            
        },
        editItem(index) {
            this.editIndex = index;
            this.isDisabled = true;
            this.paginationIsDisabled = true;
            this.editedInstance = { ...this.BehavioralReportRecommendationList[index] }
        },
        async updateRecord(index) {
            this.editIndex = null;
            this.isDisabled = false;
            this.paginationIsDisabled = false;
            let data = this.editedInstance;
            let record = await this.UpdateBehaviouralReportRecommendation(data);
            this.BehavioralReportRecommendationList[index] = record.object.data;
            return record;
        },
        Reset(){
            this.editIndex = null;
            this.isDisabled = false;
            this.paginationIsDisabled = false;
        }

    },
    async mounted() {
        await this.getBehaviouralReportRecommendation();
    }
}
</script>

<style scoped>
.pagination {
    justify-content: flex-end;
}

.pagination .page-item.active .page-link {
    font-weight: 600;
    background: #ffc801;
}

.pagination .page-item:last-child .page-link {
    background-color: transparent;
    border: none;
    width: 100% !important;
}

.pagination .page-item:first-child .page-link {
    background-color: transparent;
    border: none;
    width: 100% !important;
}

.pagination .page-item.disabled .page-link {
    color: rgb(130, 130, 130) !important;
    cursor: no-drop !important;
}

.file-upload-input {
    position: absolute;
    margin: 0;
    padding: 0;
    width: 20vh;
    height: 5vh;
    outline: none;
    opacity: 0;
    cursor: pointer;
}

.disabled {
    opacity: 0.5;
    background-color: #f2f2f2;
    display: flex;
}

.table thead th {
    text-transform: capitalize;
    color: #000;
    font-size: 15px;
    font-weight: bold;
}

.tippy-box[data-theme~="light"] {
    background-color: #fff;
    color: #333;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0px 2px 6px rgba(254, 254, 254, 0.15);
}

.tippy-arrow {
    display: none;
    color: #fff;
    box-shadow: -6px 0px 0px rgba(0, 0, 0, 0.1);
}

.tippy-filter-content {
    height: 310px;
    overflow-x: hidden;
    overflow-y: auto;
}

.bulkButton {
    font-size: 13px;
    height: 40px;
    font-weight: 600;
    width: max-content;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  /* font-family: sans-serif; */
}

.styled-table th, .styled-table td {
  border: 3px solid #ccc;
  text-align: left;
}

/* Alternate row colors */
.styled-table tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

.styled-table tbody tr:nth-child(even) {
  background-color: #ffffff;
}
/* Optional: highlight border between rows */
.styled-table tr + tr {
  border-top: 5px solid #000;
}
.truncate-cell {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


</style>


